// extracted by mini-css-extract-plugin
export default {"header":"styles_header__0kMIr","container":"styles_container__XOQxF","btn_book":"styles_btn_book__mCKXi","btn_game":"styles_btn_game__odinD"};